var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"omapi-alert",class:_vm.alertClass},[_vm._t("default"),(_vm.canClose)?_c('button',{staticClass:"unbutton close-alert",attrs:{"type":"button"},on:{"click":_vm.startCloseAlert}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }